import { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import Flex from '../Flex';
import { BaseProps, ForwardProps } from '../../types';

export interface CardMediaProps extends BaseProps {
  /** The content for the media. */
  children: ReactNode;
}

const StyledCardMedia = styled.div<Partial<CardMediaProps>>`
  img,
  video,
  audio {
    object-fit: cover;
    width: 100%;
  }
`;

const CardMedia: FunctionComponent<CardMediaProps & ForwardProps> = ({
  children,
  ...restProps
}: CardMediaProps) => {
  return (
    <Flex container as={StyledCardMedia} {...restProps}>
      {children}
    </Flex>
  );
};

export default CardMedia;
export { StyledCardMedia };
